import { useState } from "react";
import { Text, Button, Loading } from "@nextui-org/react";
import { Fragment } from "react";
import OrderCard from "../components/OrderCard";
import SearchModal from "../components/SearchModal";
import {
  AiOutlineSearch,
  AiOutlinePlus,
  AiOutlineLayout,
  AiOutlinePrinter,
} from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import PrintModal from "../components/PrintModal";
import { DatePickerInput } from "@mantine/dates";

const Home = (props) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const [print, setPrint] = useState(false);

  return (
    <Fragment>
      <div className="header">
        <div className="headerFix">
          <Text b>HOME</Text>
          <DatePickerInput
            variant="filled"
            type="range"
            value={props.value}
            onChange={(v) => {
              props.setDateFilter(v);
            }}
            allowSingleDateInRange
            valueFormat="DD MMM YYYY"
            popoverProps={{ withinPortal: true }}
          />
        </div>
      </div>
      {props.loading ? (
        <div className="orderDiv">
          <Loading type="spinner" />
        </div>
      ) : (
        <div className="orderDiv">
          {props.filteredOrders.length > 0 &&
            props.filteredOrders.map((doc, index) => {
              return (
                <OrderCard
                  key={index}
                  name={doc.name}
                  date={doc.date.slice(0, 10)}
                  products={doc.products}
                  id={doc._id}
                />
              );
            })}
        </div>
      )}
      <div className="actionContainer">
        <div className="actionDiv">
          <Button
            size="sm"
            css={{ w: "50px", h: "50px" }}
            auto
            color="error"
            rounded
            onClick={() => navigate("/dashboard/all")}
            className="cardShadow"
            icon={<AiOutlineLayout />}
          />
          <Button
            size="sm"
            css={{ w: "50px", h: "50px" }}
            auto
            rounded
            onClick={() => setIsVisible(!isVisible)}
            className="cardShadow"
            icon={<AiOutlineSearch />}
          />
          <Button
            size="sm"
            css={{ w: "50px", h: "50px" }}
            auto
            rounded
            color="warning"
            onClick={() => setPrint(!print)}
            className="cardShadow"
            icon={<AiOutlinePrinter />}
          />
          <Button
            size="sm"
            css={{ w: "50px", h: "50px" }}
            auto
            rounded
            color="success"
            className="cardShadow"
            icon={<AiOutlinePlus />}
            onClick={() => navigate("/new-order")}
          />
        </div>
      </div>
      {isVisible && (
        <SearchModal
          visible={isVisible}
          orders={props.allOrders}
          onClose={() => setIsVisible(false)}
        />
      )}
      {print && (
        <PrintModal
          visible={print}
          orders={props.allOrders}
          onClose={() => setPrint(false)}
        />
      )}
    </Fragment>
  );
};

export default Home;
